// Brand hues checked with the dataviz palette validator against the white card surface: both clear the
// lightness band, chroma floor, 3:1 contrast and CVD separation (protan ΔE 11.8).
export const TEAM_COLOR = "#5b3d99";
export const TRELLIS_COLOR = "#d91266";
export const PREVIOUS_PERIOD_COLOR = "#b9b4c7";

export const INK = {
  primary: "#1d1630",
  secondary: "#5c566b",
  muted: "#8a8597",
  grid: "#ebe8f0",
  baseline: "#cfcad8",
};

/** One hue, light to dark, for magnitude (the working-hours heatmap). The first step is "nothing". */
export const SEQUENTIAL_RAMP = ["#f4f1f8", "#e0d6ef", "#c5b3e2", "#a88dd1", "#8a68bd", "#6e4aa6", "#523283", "#3a2160"];

export const STATUS_COLORS = {
  active: "#0ca30c",
  slowing: "#fab219",
  inactive: "#d03b3b",
  never: "#8a8597",
  invited: "#8a8597",
} as const;

export const chartFont = {
  fontFamily: "inherit",
  fontSize: "13px",
};
